<template>
  <div class="pega-duplicate-container row">
    <div class="column align-self-middle pega-duplicate-label">
      重複応募
    </div>
    <div class="column align-self-middle">
      （前回の応募日）
      <span
        class="pega-duplicate-date"
        data-test="entry-date"
      >{{ entryDate | parseDate }}</span>
    </div>
    <div
      class="column align-self-middle"
      data-test="entry-job"
    >
      （応募した求人）求人ID：{{ job.id }} {{ job.name }}
    </div>
    <div class="column align-self-middle">
      <router-link :to="{ name: 'entryDetail', params: { entryId: entryId } }">
        <span class="boss-button previous-button">前回の詳細を見る</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  filters: {
    parseDate (val) {
      return (val) ? dayjs(val).format('YYYY/MM/DD') : ''
    }
  },
  props: {
    job: {
      type: Object,
      required: true
    },
    entryId: {
      type: Number,
      required: true
    },
    entryDate: {
      type: String,
      required: true
    }
  },
  computed: {
  }
}
</script>
